<template>
  <div class="home">
    <div class="shopName">{{ info.shopName }}</div>
    <div class="tips">
      <p>本券只适用于以下显示商品，未显示即不支持</p>
      <p style="margin-top: 8px">如未找到相关品类，即为该这家店铺的该品类未上架或售罄</p>
    </div>
    <div v-if="drinkList.length == 0 && !requestFlag" class="noShop">无可下单商品</div>
    <div v-if="requestFlag" class="noShop">查询商品中，请稍等</div>
    <div v-if="drinkList.length !=0" style="padding: 0 20px 80px 20px;">
      <div v-for="(item,index) in drinkList" :key="index" class="drinkItem">
        <img :src="item.productLogo">
        <div class="info">
          <p>{{item.productName}}</p>
<!--          <span class="redBox">{{item.itemNo}}</span>-->

<!--          <p v-if="type == 3 && item.productPrice != 250" style="color: #E60012">￥{{item.productPrice/100}}</p>-->
<!--          <p v-else style="color: #E60012">￥0.00</p>-->
          <p style="color: #E60012">￥{{item.productPrice/100}}</p>
<!--          v-if="type != 3"-->
          <div >
            <el-button v-if="item.productStatus ==1" type="primary" @click="toOrder(item)" style="width: 100%;background-color: #E60012;border-color:#E60012;">立即下单</el-button>
            <el-button v-else type="primary" @click="toOrder(item)" style="width: 100%;background-color: #E60012;border-color:#E60012;">已售罄</el-button>
          </div>

<!--          <div v-else>-->
<!--            <el-button v-if="item.productStatus == 1 && item.productPrice == 250" type="primary" @click="toOrder(item)" style="width: 100%;background-color: #E60012;border-color:#E60012;">立即下单</el-button>-->
<!--            <el-button v-else-if="item.productStatus !=1" type="primary" @click="toOrder(item)" style="width: 100%;background-color: #E60012;border-color:#E60012;">已售罄</el-button>-->
<!--            <el-button v-else-if="item.productStatus ==1 && item.productPrice != 250" type="primary" @click="toOrder(item)" style="width: 100%;background-color: #E60012;border-color:#E60012;">价格不适用此券</el-button>-->
<!--          </div>-->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {menu, getCan, queryCard} from "@/api/mxbc";

export default {
  name: "shop",
  data() {
    return {
      info: {},
      drinkList: [],
      canList:'',
      type:1,
      //canText:'',
      requestFlag:false,
      productName:""
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.query.cardID){
          this.cardID = this.$route.query.cardID
          localStorage.setItem('cardID', this.cardID);
        }
      },
      deep:true
    }
  },
  mounted() {
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }

    let info = JSON.parse(localStorage.getItem('shopInfo'))
    this.type = localStorage.getItem('type')
    this.info = info
    this.requestFlag = false
    // if (this.type == 2){
    //   this.productName = "新鲜冰淇淋"
    // }else if(this.type==3){
    //   this.productName = "薄荷冰淇淋"
    // }else{
    //   this.productName = "蓝莓果粒茶"
    // }
    //this.getCanList();
    this.getItems();
    this.AD();
  },
  methods:{
    AD() {
      if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
      let params = {
        cardID: localStorage.getItem('cardID'),
        type:localStorage.getItem('type') || ""
      }
      queryCard(params).then(res => {
        //code如果是0 代表可以下单 不用提示， 1的话 提示用户去查看订单
        //console.log(res, '查询卡密返回')
        //if (res.code !== 0) return this.$message.error(res.msg)
        localStorage.setItem('value', JSON.stringify(res));
        if (res.code == 0 && res.msg =="已下单") return this.$message.success('已下单，请点击取餐码页面查看')
      })
    },
    getCanList(){
      getCan().then(res=>{
        let data = res.rows
        this.canList=data
        let text = ''
        for(let i =0;i<data.length;i++){
          if (i == data.length-1){
            text = text+data[i].name
          }else{
            text = text+data[i].name+"、"
          }
        }
        this.canText = text
        //this.getItems();
      })
    },
    getItems(){
      this.requestFlag = true
      let params = {
        shopID:this.info.shopID,
        type:Number(localStorage.getItem('type')) || ""
      }
      menu(params).then(res=>{
        this.drinkList = res.data
        this.requestFlag = false
      }).catch(err=>{
        //this.requestFlag = false
        this.$message.error('获取失败，请刷新重试')
      }).finally(()=>{
        this.requestFlag = false
      })

    },
    //点击立即下单
     toOrder(item){
      let value = JSON.parse(localStorage.getItem('value'))
       if(!value) return this.$message.error('未复制完整卡密链接')
      if (value.code !== 0 || value.msg == "已下单") return this.$message.error('卡密暂不可下单')
      if(item.productStatus !=1) return this.$message.error('已售罄')
       // if(this.type == 3 && item.productPrice !=250) return this.$message.error('价格不适用此券')
      localStorage.setItem('itemInfo', JSON.stringify(item));
      this.$router.push('/item')
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 100vw;
  height: 100vh;
  .shopName {
    text-align: center;
    padding: 15px 0;
    font-size: 18px;
    border-bottom: 1px solid #F6E9EB;
  }

  .tips{
    font-size: 13px;
    padding: 10px 20px;
    color: #999999;
    //display: flex;
    //flex-direction: column;
    //align-items: center;
  }


  .drinkItem {
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: row;
    align-items: center;
    img{
      width: 160px;
      height: 120px;
      object-fit: cover;
      margin-right: 10px;
      //border: 1px solid #F6E9EB;
    }
    .info{
      width: calc(100% - 110px);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .redBox{
        max-width: 70px;
        text-align: center;
        display: inline-block;
        background-color: #E60012;
        color: #FFFFFF;
        //padding: 3px 5px;
      }
    }
  }
}

.noShop{
  margin: 20px auto;
  text-align: center;
  color: #E60012;
}
</style>